import type { RouteLocationNormalized, Router } from "vue-router";

export const recruitmentScreeningRouteName = {
  index: "recruitment-screening.index",
  show: "recruitment-screening.show",
};

export const recruitmentScreeningRoute = [
  {
    path: "/recruitment-screening",
    name: recruitmentScreeningRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "recruitment_screening",
      breadcrumbs: () => {
        return [{ title: "Recruitment Screening" }];
      },
    },
  },
  {
    path: "/recruitment-screening/:id",
    name: recruitmentScreeningRouteName.show,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "recruitment_screening",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => {
        return [{ path: router.resolve({ name: recruitmentScreeningRouteName.index }).path, title: "Recruitment Screening" }, { title: "Detail" }];
      },
    },
  },
];
